import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    title: {
        id: '_.loan_builder.expired.title',
        defaultMessage: 'Your offer’s expired: apply again?'
    },
    subtitle: {
        id: '_.loan_builder.expired.subtitle',
        defaultMessage:
            'It should be straightforward to re-apply if your business is in a similar position to before. '
    },
    reminderTitle: {
        id: '_.loan_builder.expired.reminder_title',
        defaultMessage: 'Here are a few reminders on iwoca loans:'
    },
    decision: {
        id: '_.loan_builder.expired.decision',
        defaultMessage:
            '<strong>Get a decision in 24 hours:</strong> it takes ten minutes to apply, and you’ll get a decision back within one working day.'
    },
    borrowAmount: {
        id: '_.loan_builder.expired.borrow_amount',
        defaultMessage:
            '<strong>Borrow £1,000 - £500,000:</strong> usually you can borrow about 10% of your annual revenue.'
    },
    repayEarly: {
        id: '_.loan_builder.expired.repay_early',
        defaultMessage:
            '<strong>Repay early with no fees:</strong> we’ll only charge interest for the days you have the money.'
    },
    questions: {
        id: '_.loan_builder.expired.questions',
        defaultMessage: 'If you have any questions call us on {phoneNumber}.'
    },
    phoneNumber: {
        id: '_.loan_builder.expired.phone_number',
        defaultMessage: '020 3778 0274'
    },
    cta: {
        id: '_.loan_builder.expired.cta',
        defaultMessage: 'Re-apply'
    }
});
